import { useEffect } from "react";
import { useState } from "react";

export const useProgressiveImage = (
  srcLow: string,
  srcHigh: string
): [string, { blur: boolean }] => {
  const [src, setSrc] = useState(srcLow);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;
    setSrc(srcLow);

    const img = new Image();
    img.src = srcHigh;

    img.onload = () => {
      timeout = setTimeout(() => {
        setSrc(srcHigh);
      }, 2000);
    };
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [srcLow, srcHigh]);

  return [src, { blur: src === srcLow }];
};
